import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";

function ModalEditarAlarma({ alarmaEditando, onAlarmaActualizada, onCerrarModal }) {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [mensajeTTS, setMensajeTTS] = useState("");

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (alarmaEditando) {
      setNombre(alarmaEditando.nombre || "");
      setDescripcion(alarmaEditando.descripcion || "");
      setMensajeTTS(alarmaEditando.mensaje_tts || "");
    }
  }, [alarmaEditando]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!alarmaEditando) return; // sin creación

    const dataActualizada = {
      nombre,
      descripcion,
      mensaje_tts: mensajeTTS,
    };

    axios.put(`${API_URL}/api/alarmas/${alarmaEditando.id}/`, dataActualizada, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": Cookies.get("csrftoken"),
      },
      withCredentials: true,
    })
    .then((response) => {
      onAlarmaActualizada(response.data); // Llama a la función para refrescar la lista
    })
    .catch((error) => console.error("Error editando la alarma:", error));
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h4>Editar Alarma: {alarmaEditando?.nombre}</h4>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Nombre</label>
            <input
              type="text"
              value={nombre}
              readOnly
            />
          </div>
          <div>
            <label>Descripción</label>
            <textarea
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Mensaje TTS</label>
            <textarea
              value={mensajeTTS}
              onChange={(e) => setMensajeTTS(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-success">
            Guardar
          </button>
          <button type="button" className="btn btn-secondary" onClick={onCerrarModal}>
            Cancelar
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0,
    width: "100vw", height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    minWidth: "400px",
    maxWidth: "80vw"
  }
};

export default ModalEditarAlarma;
